import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { MeasuringDeviceRevisionGetPathParameters } from 'api/actions/measuring-device-revision-get/measuring-device-revision-get-path-parameters';
import { MeasuringDeviceRevisionGetResponse } from 'api/actions/measuring-device-revision-get/measuring-device-revision-get-response';

type MeasuringDeviceRevisionGetQueryParameters = Record<string, any>;

/**
 * The path of the MeasuringDeviceRevisionGet action.
 */
export const measuringDeviceRevisionGetActionPath = new SweetPath<keyof MeasuringDeviceRevisionGetPathParameters>(
  '/api/measuring-device/revision/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized MeasuringDeviceRevisionGet actions.
 */
export default function createMeasuringDeviceRevisionGetAction(axios: AxiosInstance) {
  return function measuringDeviceRevisionGetAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: MeasuringDeviceRevisionGetPathParameters;
    query?: MeasuringDeviceRevisionGetQueryParameters;
  }) {
    const path = measuringDeviceRevisionGetActionPath.insert(parameters);

    return axios.request<MeasuringDeviceRevisionGetResponse, MeasuringDeviceRevisionGetResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
